import React from 'react';

import PropTypes from 'prop-types';
import {
  Table as QuoteApprovalDashboardTable,
  Thead,
  Tbody,
  Tr,
  Th
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Row from './Row';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Table = ({ data, fetchOrders }) => {
  const {
    iotOrderDetailsSection: { orderFulfillmentDashboardHeaders }
  } = useLocalizedStringsContext();

  return (
    <QuoteApprovalDashboardTable>
      <Thead style={{ background: '#e2e2e2' }}>
        <Tr>
          {orderFulfillmentDashboardHeaders.map(header => (
            <Th
              key={`orderFulfillmentHeader-${header}`}
              style={{ textAlign: 'center' }}
            >
              {header}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {data &&
          data.map((order, index) => (
            <Row
              key={order.id}
              index={index}
              order={order}
              fetchOrders={fetchOrders}
            />
          ))}
      </Tbody>
    </QuoteApprovalDashboardTable>
  );
};

Table.propTypes = {
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Table;
